import { translate, translateRich, useLocale } from "../localization";
import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { AppButton } from "./ui";

/**
 * Props:
 * - guide: the raw guide object (has at least { sk, name })
 * - isOwner: boolean (controls which buttons you show/enable, if desired)
 * - onEdit(guideId: string)
 * - onClone(guide: object)
 * - onDelete(guideId: string): Promise/void
 */
const GuideCard = ({ guide, isOwner, onEdit, onClone, onDelete }) => {
  useLocale();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  // Extract the actual guide id from the `sk` field: "GUIDE#{id}"
  const extractGuideId = (g) => g.sk.split("GUIDE#")[1];
  const guideId = extractGuideId(guide);

  const handleDeleteClick = () => setConfirmOpen(true);

  const handleConfirmDelete = async () => {
    try {
      setDeleting(true);
      await onDelete?.(guideId);
    } finally {
      setDeleting(false);
      setConfirmOpen(false);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6">{guide.name}</Typography>
          <Typography variant="body2">{translateRich("ID: {value0}", {
  value0: guideId
})}</Typography>
        </CardContent>
        <CardActions>
          <AppButton size="small" kind="ghost" onClick={() => onEdit?.(guideId)}>{translate("Edit")}</AppButton>
          <AppButton size="small" kind="ghost" onClick={() => onClone?.(guide)}>{translate("Clone")}</AppButton>
          <AppButton size="small" kind="danger" onClick={handleDeleteClick} disabled={deleting}>{translate("Delete")}</AppButton>
        </CardActions>
      </Card>

      <Dialog
        open={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        PaperProps={{ className: "guidesDialogPaper" }}
      >
        <DialogTitle>{translate("Delete this guide?")}</DialogTitle>
        <DialogContent>
          <Typography>{translateRich("This action cannot be undone. Are you sure you want to delete \u201C{value0}\u201D?", {
  value0: guide.name
})}</Typography>
        </DialogContent>
        <DialogActions>
          <AppButton kind="ghost" onClick={() => setConfirmOpen(false)} disabled={deleting}>{translate("Cancel")}</AppButton>
          <AppButton onClick={handleConfirmDelete} kind="danger" disabled={deleting}>
            {deleting ? translate("Deleting\u2026") : translate("Delete")}
          </AppButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GuideCard;
